// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"8":"editor","36":"redirect_form","538":"editor_dev_login","818":"client"}[chunkId] || chunkId) + "." + {"8":"65b6206e","36":"5fd60e16","47":"12f64e1c","355":"a05658cb","398":"d75e1133","415":"b1e6bdb4","521":"59c1c308","538":"52828987","818":"c0c3261a","820":"373207b0"}[chunkId] + ".chunk.js";
};